<template>
  <div class="certification-lookup">
    <div class="certification-lookup__wrapper">
      <input
        v-model="certificationId"
        class="certification-lookup__input ine-input"
        type="text"
        placeholder="Certification ID"
      />
      <button
        type="submit"
        class="btn btn--primary btn--default-icon-color certification-lookup__verify-button"
        :disabled="!certificationId"
        @click="redirectToCertificate()"
      >
        Verify
        <ExternalLinkIcon />
      </button>
    </div>

    <div class="certification-lookup__message">
      Looking for your certifications? View them on
      <router-link
        :to="{
          name: 'user-dashboard',
          params: { mode: 'certifications' },
        }"
        class="certification-lookup__message__link"
      >
        your profile</router-link
      >.
    </div>
  </div>
</template>

<script>
import { ExternalLinkIcon } from 'vue-feather-icons'

export default {
  name: 'CertificationLookup',
  components: {
    ExternalLinkIcon,
  },
  data() {
    return {
      certificationId: '',
      acredibleURL: process.env.VUE_APP_ACREDIBLE_URL,
    }
  },
  methods: {
    redirectToCertificate() {
      window.open(`//${this.acredibleURL}/${this.certificationId}`, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.certification-lookup {
  &__wrapper {
    display: flex;
    justify-content: center;
  }
  &__input {
    width: 100%;
    margin-bottom: 20px;
    max-width: 406px;
  }
  &__verify-button {
    margin-left: 15px;
  }
  &__message {
    width: 100%;
    text-align: center;
    font-size: rem(16px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(24px);
    color: var(--light-blue-gray);
    &__link {
      color: var(--purple-pale);
    }
  }
}
</style>
